module.exports = __webpack_public_path__ + "static/mural-ae9a208bc3adb89efc0dd2edddc9a92c.jpg";